import { Controller } from "@hotwired/stimulus"

// Toggles "scrolled" on sticky navs when their scroll container moves, for border effects.
export default class extends Controller {
  static targets = ["nav"]

  connect() {
    this.scrollContainer = this.findScrollContainer()
    this.usesWindowScroll = this.scrollContainer === window

    this.boundUpdate = this.update.bind(this)
    this.update()

    if (this.usesWindowScroll) {
      window.addEventListener("scroll", this.boundUpdate, { passive: true })
    } else {
      this.scrollContainer.addEventListener("scroll", this.boundUpdate, { passive: true })
    }
  }

  disconnect() {
    if (this.usesWindowScroll) {
      window.removeEventListener("scroll", this.boundUpdate)
    } else {
      this.scrollContainer?.removeEventListener("scroll", this.boundUpdate)
    }
  }

  findScrollContainer() {
    const mainCol = document.querySelector(".main-content-column")
    const scrollHost = mainCol?.querySelector(
      ".full-height-minus-header, .main-content, .full-height"
    )
    if (scrollHost) return scrollHost

    let element = this.element.parentElement
    while (element && element !== document.body) {
      const { overflowY } = getComputedStyle(element)
      if (/(auto|scroll|overlay)/.test(overflowY) && element.scrollHeight > element.clientHeight) {
        return element
      }
      element = element.parentElement
    }

    return window
  }

  scrollOffset() {
    if (this.usesWindowScroll) return window.scrollY
    return this.scrollContainer?.scrollTop ?? 0
  }

  update() {
    const scrolled = this.scrollOffset() > 0
    this.navTargets.forEach((nav) => nav.classList.toggle("scrolled", scrolled))
    this.pageHeaders().forEach((header) => header.classList.toggle("scrolled", scrolled))
  }

  pageHeaders() {
    return this.element.querySelectorAll(".header.sticky-top:not(.turbo-header)")
  }
}
